import { render, staticRenderFns } from "./productdetailtzbs.vue?vue&type=template&id=621b3e39&scoped=true&"
import script from "./productdetailtzbs.vue?vue&type=script&lang=js&"
export * from "./productdetailtzbs.vue?vue&type=script&lang=js&"
import style0 from "./productdetailtzbs.vue?vue&type=style&index=0&id=621b3e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b3e39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621b3e39')) {
      api.createRecord('621b3e39', component.options)
    } else {
      api.reload('621b3e39', component.options)
    }
    module.hot.accept("./productdetailtzbs.vue?vue&type=template&id=621b3e39&scoped=true&", function () {
      api.rerender('621b3e39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/physical/productdetailtzbs.vue"
export default component.exports